import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHashElement = () => {
    const location = useLocation();

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: "smooth" });
            } else {
                // Retry after a short delay in case of lazy loading or render delay
                setTimeout(() => {
                    const element = document.getElementById(location.hash.substring(1));
                    if (element) {
                        element.scrollIntoView({ behavior: "smooth" });
                    }
                }, 100);
            }
        }
    }, [location]);

    return null;
};

export default ScrollToHashElement;
